import { useState, useCallback } from 'react';

type EventType = 1 | 3;

export default function OrderCenterOrderDetailOrderStatus() {
  const [eventType, setEventType] = useState<EventType>(1); // 1 默认事件 3 修改了小费
  const [waitReplyDriverConfig, setWaitReplyDriverConfig] = useState<any>({}); // 获取播单司机接口数据-轮询更新
  const [addFeeOrderList, setAddFeeOrderList] = useState<string[]>([]); // 将加过小费的订单 缓存起来。

  const setWaitReplyDriverConfigCb = useCallback((val) => {
    setWaitReplyDriverConfig(val);
  }, []);
  const setEventTypeCb = useCallback((val) => {
    setEventType(val);
  }, []);
  const setAddFeeOrderListCb = useCallback((val) => {
    setAddFeeOrderList(val);
  }, []);
  return {
    eventType,
    waitReplyDriverConfig,
    addFeeOrderList,
    setEventTypeCb,
    setWaitReplyDriverConfigCb,
    setAddFeeOrderListCb,
  };
}
